export default __webpack_public_path__ + "static/media/disabled-success.af9f9008.svg";